import { isNullOrUndefined } from 'cgil-html-utils';

export const getFloatParam = (paramName, defaultValue = 0.0) => {
// https://developer.mozilla.org/en-US/docs/Web/API/HTMLHyperlinkElementUtils/search
// substring(1) to drop the leading "?"
  const uri = window.location.search.substring(1);
  const params = new URLSearchParams(uri);
  const value = parseFloat(params.get(paramName), 10);
  if (Number.isNaN(value)) {
    return defaultValue;
  }
  return value;
};

export const getIntegerParam = (paramName, defaultValue = 0.0) => {
  const uri = window.location.search.substring(1);
  const params = new URLSearchParams(uri);
  const value = parseInt(params.get(paramName), 10);
  if (Number.isNaN(value)) {
    return defaultValue;
  }
  return value;
};

export const getBoolParam = (paramName, defaultValue = false) => {
  const uri = window.location.search.substring(1);
  const params = new URLSearchParams(uri);
  const value = params.get(paramName);
  if (isNullOrUndefined(value)) {
    return defaultValue;
  }
  if (value === 'true') {
    return true;
  }
  return false;
};

export const convertEnt = (text) => {
  if (isNullOrUndefined(text)) return '';
  let textFiltered = `${text}`.trim();
  textFiltered = textFiltered.replace(/&#39;/g, '\'');
  textFiltered = (`${text}`).replace(/&#\d+;/gm, (s) => String.fromCharCode(
    s.match(/\d+/gm)[0],
  ));
  return textFiltered;
};
